// libraries
import React from "react";
import classNames from "classnames/bind";

// components
import { EventItem, Heading } from "src/components";
import NewAdItem from "../AdItem/NewAdItem";

// icons
import { CalenderFill } from "src/assets/icons";

// helper
import { toAdFormat, toEventFormat } from "./util";

// styles
import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const ListWrap = ({ heading, items, limit, to, handleClick }) => {
  const checkForAd = (_data) => {
    if (_data.isadvertisement || _data.Advertisement) return true;

    return false;
  };

  const adFormat = (_data) => {
    if (_data.isadvertisement) {
      return toAdFormat(_data);
    } else {
      return toAdFormat(_data.Advertisement);
    }
  };
  console.log(items);

  return (
    <div className={cx("list_wrap")}>
      <Heading heading={heading} to={to} handleClick={handleClick} />
      {items && items.length > 0 ? (
        <div className={cx("items")}>
          {(limit ? items?.slice(0, 4) : items)?.map((item, index) =>
            checkForAd(item) ? (
              // <AdItem key={index} data={adFormat(item)} ratio="ration-16-9" />
              <NewAdItem key={index} data={adFormat(item)} />
            ) : (
              <EventItem key={index} data={toEventFormat(item)} index={index} />
            )
          )}
        </div>
      ) : (
        <div className={cx("no-items-found")}>
          <CalenderFill />
          <p>No events found for {heading}</p>
        </div>
      )}
    </div>
  );
};

export default ListWrap;
